export enum AcceptedLanguage {
  FRENCH = 'fr',
  GERMAN = 'de'
}

export const DEFAULT = AcceptedLanguage.FRENCH;